import { render, staticRenderFns } from "./domesticTable.vue?vue&type=template&id=db90d08c&"
import script from "./domesticTable.vue?vue&type=script&lang=js&"
export * from "./domesticTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports